module.exports = __webpack_public_path__ + "static/media/profile.7a576786.png";